function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import { InputEl } from "common/components/input";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { SelectEl } from "common/components/select";
import { RadioButtonEl } from "common/components/radio-button";
import { ButtonEl } from "common/components/button";
import { Placement } from "common/components/tooltip/types";
import { ButtonTheme } from "common/components/button/constants";
import { Permission } from "common/report/constants";
import { CheckboxEl } from "common/components/checkbox";
export function template() {
  const {
    selectedDataResidency,
    timezones,
    selectedTimezone,
    selectedOrganizationId
  } = this.state;
  const orgData = this.attr("orgs");
  const isSetup = this.attr("is-setup");
  const isFyt = this.attr("is-fyt");
  const t = this.getContext("i18n").t;
  return /* @__PURE__ */ jsx("div", { sel: ".create-project-field-container", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(InputEl, { sel: ".project-name-input", attrs: _objectSpread({
    "field-id": "project-name",
    label: t("settings.project-settings.create.name"),
    placeholder: t("settings.project-settings.create.name-placeholder")
  }, isFyt ? {
    "help-text": t("settings.project-settings.create.name-help")
  } : {}), on: {
    input: (ev) => this.update({
      projectName: ev.target.value
    })
  }, hook: {
    insert: (_ref) => {
      let {
        elm
      } = _ref;
      return requestAnimationFrame(() => elm.focus());
    }
  }, "data-sentry-element": "InputEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx("div", { sel: ".data-residency-radio-group" }, /* @__PURE__ */ jsx("div", { sel: ".label .mp-input-label" }, t("settings.project-settings.create.store-data"), /* @__PURE__ */ jsx("div", { sel: ".info" }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
    icon: "info"
  }, "data-sentry-element": "SvgIconEl", "data-sentry-source-file": "template.tsx" }), /* @__PURE__ */ jsx(TooltipEl, { attrs: {
    placement: Placement.Bottom,
    "max-width": "300px"
  }, "data-sentry-element": "TooltipEl", "data-sentry-source-file": "template.tsx" }, t("settings.project-settings.create.eu-info")))), /* @__PURE__ */ jsx("div", { sel: ".radio-btn", on: {
    click: () => this.update({
      selectedDataResidency: "US"
    })
  } }, /* @__PURE__ */ jsx(RadioButtonEl, { selected: selectedDataResidency === "US", children: "\u{1F1FA}\u{1F1F8} ".concat(t("settings.project-settings.create.us-option")), "data-sentry-element": "RadioButtonEl", "data-sentry-source-file": "template.tsx" })), /* @__PURE__ */ jsx("div", { sel: ".radio-btn", on: {
    click: () => this.update({
      selectedDataResidency: "EU"
    })
  } }, /* @__PURE__ */ jsx(RadioButtonEl, { selected: selectedDataResidency === "EU", children: "\u{1F1EA}\u{1F1FA} ".concat(t("settings.project-settings.create.eu-option")), "data-sentry-element": "RadioButtonEl", "data-sentry-source-file": "template.tsx" })), this.helpers.hasIndiaDatacenterAccess() && /* @__PURE__ */ jsx("div", { sel: ".radio-btn", on: {
    click: () => this.update({
      selectedDataResidency: "IN"
    })
  } }, /* @__PURE__ */ jsx(RadioButtonEl, { selected: selectedDataResidency === "IN", children: "\u{1F1EE}\u{1F1F3} ".concat(t("settings.project-settings.create.in-option")) }))), /* @__PURE__ */ jsx("div", { sel: ".timezones-dropdown-area" }, /* @__PURE__ */ jsx("div", { sel: ".mp-input-label" }, t("settings.project-settings.create.timezone")), /* @__PURE__ */ jsx(SelectEl, { sel: ".timezones-dropdown", attrs: {
    options: timezones.map((timezoneEntry) => timezoneEntry[1]),
    "label-transform": "uppercase",
    tabindex: 0,
    "selected-option": selectedTimezone ? selectedTimezone[1] : "",
    "force-visibility": true
  }, on: {
    change: this.helpers.handleChangeSelectedTimezone
  }, "data-sentry-element": "SelectEl", "data-sentry-source-file": "template.tsx" })), this.helpers.hasFeatureFlag() ? /* @__PURE__ */ jsx("div", { sel: ".b2b-checkbox-area" }, /* @__PURE__ */ jsx(CheckboxEl, { attrs: {
    checked: this.state.isB2BProject
  }, on: {
    click: () => this.update({
      isB2BProject: !this.state.isB2BProject
    })
  } }, t("settings.project-settings.create.enable-b2b"))) : null, orgData && orgData.length > 1 && /* @__PURE__ */ jsx("div", { sel: ".select-org" }, /* @__PURE__ */ jsx("div", { sel: ".select-org-label" }, t("settings.project-settings.create.organization")), /* @__PURE__ */ jsx("div", { sel: ".mp-chrome-create-project-modal-radio-button-container" }, orgData.map((org) => {
    const disabled = !this.helpers.orgHasPerm(org, Permission.CreateProject);
    return !disabled && /* @__PURE__ */ jsx("div", { sel: ".radio-btn" }, /* @__PURE__ */ jsx(RadioButtonEl, { selected: selectedOrganizationId === org.id, disabled, onClick: () => !disabled && this.update({
      selectedOrganizationId: org.id
    }), children: org.name }));
  }))), /* @__PURE__ */ jsx("div", { style: {
    textAlign: this.attr("button-area-align") || "right"
  } }, isSetup ? null : !isFyt && /* @__PURE__ */ jsx(ButtonEl, { sel: ".skip-btn", attrs: {
    theme: ButtonTheme.Tertiary,
    role: "button",
    tabindex: 0
  }, on: {
    click: this.helpers.clickedCancel
  } }, t("settings.project-settings.create.cancel")), /* @__PURE__ */ jsx(ButtonEl, { sel: ".create-btn", attrs: {
    theme: ButtonTheme.Primary,
    role: "button",
    tabindex: 0,
    disabled: this.helpers.isSubmitDisabled(),
    icon: this.state.createProjectLoading ? "spinner" : void 0
  }, on: {
    click: !this.helpers.isSubmitDisabled() && this.helpers.createProject
  }, "data-sentry-element": "ButtonEl", "data-sentry-source-file": "template.tsx" }, t("settings.project-settings.create.create"))));
}
